@if (knowledgeSource?.config?.websiteScrapeConfig && !knowledgeSource.isSuggested) {
  @if (knowledgeSource?.config?.websiteScrapeConfig?.scrapeProgress !==
    WebsiteScrapeConfigProgress.WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE) {
    <span class="status-text">{{ 'WEBSITE_SCRAPE.SCRAPE_NOT_DONE' | translate }}</span>
  } @else if (!isTrainingInfoFinished(knowledgeSource.training)) {
    <span class="status-text">{{ 'WEBSITE_SCRAPE.TRAINING_NOT_DONE' | translate }}</span>
  } @else if (knowledgeSource?.config?.websiteScrapeConfig?.lastScraped) {
    <span class="status-text">{{ 'WEBSITE_SCRAPE.LAST_SCRAPED' | translate: { lastScraped: getLastScraped() } }}</span>

    @if (!getScrapedPagesCount()) {
      -
      <span class="error-text">
        {{ 'WEBSITE_SCRAPE.ERRORS.DESCRIPTION' | translate }}
      </span>
    } @else {
      <span class="status-text">
        -
        {{
        'WEBSITE_SCRAPE.NUMBER_OF_PAGES_TRAINED'
        | translate: { trainedPagesCount: getTrainedPagesCount(), scrapedPagesCount: getScrapedPagesCount() }
        }}
      </span>
    }
    @if (allowRescrapeWebsite) {
      <span class="status-text">
        - <a (click)="rescrape()">{{ 'WEBSITE_SCRAPE.RESCRAPE' | translate }}</a>
      </span>
    }
  }
}
